import { Notification, MessageBox, Message } from 'element-ui'
import store from '@/store'
import router from '@/router'
import { getToken } from '@/utils/auth'
import { createHttpService } from '@/utils/http-service'
import {
  createAuthExpiredHandler,
  showBusinessError,
  showTransportError
} from '@/utils/request-side-effects'

const service = createHttpService({
  baseURL: process.env.VUE_APP_BASE_API,
  getAuthorizationToken: getToken,
  onAuthExpired: createAuthExpiredHandler({
    store,
    router,
    MessageBox
  }),
  onBusinessError: payload => showBusinessError({
    Notification
  }, payload),
  onTransportError: error => showTransportError({
    Message
  }, error)
})

export default service
